<template>
    <form class="form-horizontal" @submit.prevent="submit()">
        <template v-for="o in data">
            <div class="form-group"  >
                <label for="active" class="col-sm-2 control-label">{{o.title}}</label>
                <div class="col-sm-10">
                    <el-switch 
                        v-bind:id="o.key"
                        v-model="o.value"
                        on-text="SI"
                        off-text="NO"
                        v-on:change="loginvalue(o)"
                        >
                    </el-switch>
                     <a href="backend/ajustes-mis-beneficios" v-if="o.key == 'MENU-BENEFICIOS'"><i class="material-icons" data-toggle="tooltip" title="Editar">edit</i>
                    </a>
                </div>
            </div>
        </template>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button type="submit" class="btn btn-primary" >Guardar</button>
            </div>
        </div>
    </form>
</template>
<script>
import ElementUI from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';
import Vue from 'vue';


export default {
    data:function(){
        var aux = this.optionmenu.find(function(e){
            return e.key === 'MENU-LOGIN-HOME';
        });

        return {
            data: _.cloneDeep(this.optionmenu),
            login: aux.value 
        }
    },
    components:{ElSwitch},
    props:['optionmenu'],
    methods:{
        submit:function(){
            var self = this;

            axios({
                url:"backend/setting-menu-citizen",
                method:"PUT",
                data: this.data
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }
        ,
        loginvalue:function(op){

            if(op.key == 'MENU-LOGIN-HOME' ){
                if(!op.value){
                    this.data.forEach(function(e) {
                        if(e.key != 'MENU-LOGIN-HOME')
                            e.value = op.value;
                    });
                }
                else{
                    var optionmenu = this.optionmenu;
                   
                    this.data.forEach(function(e){
                        if(e.key != 'MENU-LOGIN-HOME'){
                           e.value = optionmenu.find(o => e.key === o.key).value;
                        }
                    }); 
                }
            }
           
        }
    }

}
</script>